import { Injectable } from '@angular/core';
@Injectable()
export class NavigationUiUtilsService {
    public MAX_MAIN_ITEMS = 2;
    public MAX_BUSINESSFIELD_ITEMS = 3;

    constructor() {}

    public setInitialNavValues(): any {
        return {
            sitenavigationTopSegmentSelected0: {
                selected: false
            },
            sitenavigationTopSegmentSelected1: {
                selected: false
            },
            siteNavigationSecondLevelSelectedSegment0: 'navbartogglesegment0level0item0',
            siteNavigationSecondLevelSelectedSegment1: 'navbartogglesegment1level1item0',
            siteNavigationThirdLevelSelectedSegment0: '',
            siteNavigationThirdLevelSelectedSegment1: ''
        };
    }

    public preselectBusinessFieldEntry(children: any[], businessField: string, model: any): any {
        const mainMenueItem = children;
        for (let i = 0, firstLevelNavigation; i < this.MAX_MAIN_ITEMS; i++) {
            firstLevelNavigation = mainMenueItem[i].Children;
            for (let j = 0; j <= this.MAX_BUSINESSFIELD_ITEMS; j++) {
                if (firstLevelNavigation[j] && firstLevelNavigation[j].TechnicalName.toLowerCase() === 'safety') {
                    model['siteNavigationSecondLevelSelectedSegment' + i] = 'navbartogglesegment' + i + 'level' + i + 'item' + j;
                    return model;
                }
            }
        }
    }
}
